import { rmID } from './../types/products';
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { CALL_API } from '../middleware';
import {
  GetDistributorCommitmentAmount,
  GetOnboardingCompletedDetailsReportResponse,
  GetOnboardingDetailsReportResponse,
  GetOnBoardingSummaryReportResponse,
  OnBoardingDetailReportType,
  ReportFilterType,
  ReportsListRes,
} from '../types/api-types';
import {
  ONBOARDING_SUMMARY_REPORT,
  ONBOARDING_SUMMARY_REPORT_SUCCESS,
  ONBOARDING_DETAIL_REPORT,
  ONBOARDING_DETAIL_REPORT_SUCCESS,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS,
  ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_SUMMARY_REPORT_DOWNLOAD,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS,
  DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD,
  DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL,
  ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS,
  DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT,
  DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS,
  ONBOARDING_COMPLETED_REPORT_DOWNLOAD,
  ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS,
  GET_REPORTS_INVESTOR_LIST_SUCCESS,
  GET_REPORTS_INVESTOR_LIST,

  GET_REPORTS_DETAILED_HOLDINGS_SUCCESS,
  GET_REPORTS_DETAILED_HOLDINGS,
  GET_MF_TRANSACTION_WISE_REPORT_SUCCESS,
  GET_MF_TRANSACTION_WISE_REPORT,
  HOLDING_REPORT_SUCCESS,
  HOLDING_REPORT,
  PORTFOLIO_XIRR_REPORT_SUCCESS,
  PORTFOLIO_XIRR_REPORT,
  GET_REPORTS_TRANSACTION_HISTORY_SUCCESS,
  GET_REPORTS_TRANSACTION_HISTORY,
  CAPITAL_GAIN_STATEMENT_SUCCESS,
  CAPITAL_GAIN_STATEMENT,
  CAPITAL_GAIN_STATEMENT_INVESTOR_SUCCESS,
  CAPITAL_GAIN_STATEMENT_INVESTOR,
  GET_CUSTOMER_TRANSACTION_HISTORY_REPORT_SUCCESS,
  GET_CUSTOMER_TRANSACTION_HISTORY_REPORT,
  GET_CLIENT_STATEMENT,
  GET_CLIENT_STATEMENT_SUCCESS,
  REN_GET_CLIENT_STATEMENT_SUCCESS,
  REN_GET_CLIENT_STATEMENT,
  CREATE_CLIENT_STATEMENT_SUCCESS,
  CREATE_CLIENT_STATEMENT,
  CreateClientStatementRequestBody,
  CreateClientStatementResponseBody,
  GET_CLIENT_STATEMENT_LIST_SUCCESS,
  GET_CLIENT_STATEMENT_LIST,
  GetClientStatementListRequestBody,
  GetClientStatementListResponseBody,
  UPDATE_CLIENT_STATEMENT_STATUS_SUCCESS,
  UPDATE_CLIENT_STATEMENT_STATUS,
  UpdateClientStatementStatusRequestBody,
  UpdateClientStatementStatusResponseBody,
  CLIENT_STATEMENT_DOWNLOAD_SUCCESS,
  CLIENT_STATEMENT_DOWNLOAD,
  ClientStatementDownloadRequestBody,
  GET_REPORTS_ANALYST_INVESTOR_LIST_SUCCESS,
  GET_REPORTS_ANALYST_INVESTOR_LIST,
  GET_DEEMED_OVD_SUCCESS,
  GET_DEEMED_OVD,
  T1_REPORT_SUCCESS,
  T1_REPORT,
} from '../types/onBoarding';
import { encodeBase64 } from '../../utils/utilityFunctions';
import { CONTENT_TYPE } from '../../utils/constant';

const updatedFromAndToDates = (params: {
  from: string;
  to: string;
}): { from: string; to: string } => {
  const { from, to } = params;
  const fromDate = new Date(from);
  fromDate.setHours(0, 0, 0, 0);
  const toDate = new Date(to);
  toDate.setHours(23, 59, 59, 999);
  return { from: fromDate.toISOString(), to: toDate.toISOString() };
};

export const getOnBoardingSummary =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<GetOnBoardingSummaryReportResponse[]> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/onboardingSummary`,
          method: 'GET',
          types: [ONBOARDING_SUMMARY_REPORT, ONBOARDING_SUMMARY_REPORT_SUCCESS],
          params: { ...params, from, to },
        },
      });
    };

export const getOnBoardingDetails =
  (params: OnBoardingDetailReportType) =>
    async (dispatch: any): Promise<GetOnboardingDetailsReportResponse> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/onboardingDetails`,
          method: 'GET',
          types: [ONBOARDING_DETAIL_REPORT, ONBOARDING_DETAIL_REPORT_SUCCESS],
          params: {
            ...params,
            from,
            to,
          },
        },
      });
    };

export const getDistributorWiseOnBoardingSummary =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<GetOnBoardingSummaryReportResponse[]> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/distributorWiseOnboardingSummary`,
          method: 'GET',
          types: [
            DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT,
            DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_SUCCESS,
          ],
          params: {
            ...params,
            from,
            to,
          },
        },
      });
    };
export const onBoardingSummaryDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/onboardingSummary`,
          method: 'GET',
          types: [ONBOARDING_SUMMARY_REPORT_DOWNLOAD, ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS],
          params: { ...params, from, to, downloadFile: params.downloadFile },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };
export const onBoardingDetailsDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/onboardingDetails`,
          method: 'GET',
          types: [ONBOARDING_DETAIL_REPORT_DOWNLOAD, ONBOARDING_DETAIL_REPORT_DOWNLOAD_SUCCESS],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const onBoardingDetailsDownloadAllFields =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/allApplicationsData`,
          method: 'GET',
          types: [
            ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL,
            ONBOARDING_DETAIL_REPORT_DOWNLOAD_ALL_SUCCESS,
          ],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const distributorWiseOnBoardingSummaryDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/distributorWiseOnboardingSummary`,
          method: 'GET',
          types: [
            DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD,
            DISTRIBUTOR_ONBOARDING_SUMMARY_REPORT_DOWNLOAD_SUCCESS,
          ],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };
export const distributorWiseCommitmentAmountDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/distributorWiseCommitmentAmount`,
          method: 'GET',
          types: [
            DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD,
            DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_DOWNLOAD_SUCCESS,
          ],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };
export const getDistributorWiseCommitmentAmount =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<GetDistributorCommitmentAmount[]> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/distributorWiseCommitmentAmount`,
          method: 'GET',
          types: [DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT, DISTRIBUTOR_COMMITMENT_AMOUNT_REPORT_SUCCESS],
          params: {
            ...params,
            from,
            to,
          },
        },
      });
    };

export const getCompletedApplications =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<GetOnboardingCompletedDetailsReportResponse> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/completedApplications`,
          method: 'GET',
          types: [
            DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT,
            DISTRIBUTOR_COMPLETED_APPLICATIONS_REPORT_SUCCESS,
          ],
          params: {
            ...params,
            limit: 10,
            sort: 'applicationNumber',
            order: 'DESC',
            from,
            to,
          },
        },
      });
    };

export const distributorOnboardingCompletedDownload =
  (params: ReportFilterType) =>
    async (dispatch: any): Promise<any> => {
      const { from, to } = updatedFromAndToDates(params);
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/completedApplications`,
          method: 'GET',
          types: [ONBOARDING_COMPLETED_REPORT_DOWNLOAD, ONBOARDING_COMPLETED_REPORT_DOWNLOAD_SUCCESS],
          params: {
            ...params,
            from,
            to,
            downloadFile: params.downloadFile,
          },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const getReportsInvestorList =
  (body: { rmId: string, clientCode?: string, reportName?: string }) =>
    async (dispatch: any): Promise<ReportsListRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/investorList`,
          method: 'POST',
          types: [GET_REPORTS_INVESTOR_LIST_SUCCESS, GET_REPORTS_INVESTOR_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getReportsDetailedHoldings =
  (body: {
    clientCode: string;
    end: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/detailed-holding-report`,
          method: 'POST',
          types: [GET_REPORTS_DETAILED_HOLDINGS_SUCCESS, GET_REPORTS_DETAILED_HOLDINGS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const getReportsTransactionHistory =
  (body: {
    clientCode: string;
    investorName: string;
    start: string;
    end: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/transaction-history-report`,
          method: 'POST',
          types: [GET_REPORTS_TRANSACTION_HISTORY_SUCCESS, GET_REPORTS_TRANSACTION_HISTORY],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };


export const getMFTransactionWiseReport =
  (body: {
    investorName: string;
    end: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/mf-transaction-wise-report`,
          method: 'POST',
          types: [GET_MF_TRANSACTION_WISE_REPORT_SUCCESS, GET_MF_TRANSACTION_WISE_REPORT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };
export const getClientStatementPDF =
  (body: {
    rmID: string;
    end: string;
    clientCode: string;
    // customer_name: string;
    // portfolio: string;
    from: string;
    // report_date: string;
    family: boolean;
    // requested_reports: Array<number>
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          // url: `/onboarding/reports/client-report-download`,
          url: `/pdf/onboarding-application/wms-client-statement`,
          method: 'POST',
          types: [GET_CLIENT_STATEMENT_SUCCESS, GET_CLIENT_STATEMENT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.PDF,
        },
      });
    };

export const renewedClientStatementPDF =
  (body: {
    clientCode: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/client-report-static`,
          method: 'POST',
          types: [REN_GET_CLIENT_STATEMENT_SUCCESS, REN_GET_CLIENT_STATEMENT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.PDF,
        },
      });
    };

export const getHoldingReport =
  (body: {
    clientCode: string;
    end: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/holding-Report`,
          method: 'POST',
          types: [HOLDING_REPORT_SUCCESS, HOLDING_REPORT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };


export const getCGStatementReport =
  (body: {
    investorName: string;
    start: string;
    end: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/capitalGainStatement`,
          method: 'POST',
          types: [CAPITAL_GAIN_STATEMENT_SUCCESS, CAPITAL_GAIN_STATEMENT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };


export const getCGInvestorReport =
  (body: {
    clientCode: string;
    rmId: string;
    start: string;
    end: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/customer-cg-statement-report`,
          method: 'POST',
          types: [CAPITAL_GAIN_STATEMENT_INVESTOR_SUCCESS, CAPITAL_GAIN_STATEMENT_INVESTOR],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };


export const getCustomerTransactionHistoryReport =
  (body: {
    clientCode: string;
    rmId: string;
    start: string;
    end: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/customer-transaction-history-report`,
          method: 'POST',
          types: [GET_CUSTOMER_TRANSACTION_HISTORY_REPORT_SUCCESS, GET_CUSTOMER_TRANSACTION_HISTORY_REPORT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const createClientStatement =
  (body: CreateClientStatementRequestBody) =>
    async (dispatch: any): Promise<CreateClientStatementResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/create-client-statement',
          method: 'POST',
          types: [CREATE_CLIENT_STATEMENT_SUCCESS, CREATE_CLIENT_STATEMENT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getClientStatementList =
  (body: GetClientStatementListRequestBody) =>
    async (dispatch: any): Promise<GetClientStatementListResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/client-statements-list',
          method: 'POST',
          types: [GET_CLIENT_STATEMENT_LIST_SUCCESS, GET_CLIENT_STATEMENT_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const updateClientStatementStatus =
  (body: UpdateClientStatementStatusRequestBody) =>
    async (dispatch: any): Promise<UpdateClientStatementStatusResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/update-client-statement-status',
          method: 'POST',
          types: [UPDATE_CLIENT_STATEMENT_STATUS_SUCCESS, UPDATE_CLIENT_STATEMENT_STATUS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const clientStatementDownload =
  (body: ClientStatementDownloadRequestBody) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/client-statement-download',
          method: 'POST',
          types: [CLIENT_STATEMENT_DOWNLOAD_SUCCESS, CLIENT_STATEMENT_DOWNLOAD],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.PDF,
        },
      });
    };

export const getReportsAnalystInvestorList =
  (body: { analystId: string }) =>
    async (dispatch: any): Promise<ReportsListRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/analystInvestorList`,
          method: 'POST',
          types: [GET_REPORTS_ANALYST_INVESTOR_LIST_SUCCESS, GET_REPORTS_ANALYST_INVESTOR_LIST],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getDeemedOVDReport =
  (body: {
    clientCode: string;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/deemedOVD`,
          method: 'POST',
          types: [GET_DEEMED_OVD_SUCCESS, GET_DEEMED_OVD],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const getPortfolioXirrReport =
  (body: {
    clientCode: string;
    rmId: string;
    end: string;
    isPDF: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/xirr-report`,
          method: 'POST',
          types: [PORTFOLIO_XIRR_REPORT_SUCCESS, PORTFOLIO_XIRR_REPORT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const getT1Report =
  (body: {
    clientCode: string;
    rmId: string;
    end: string;
    isPDF: boolean;
  }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/t1-report`,
          method: 'POST',
          types: [T1_REPORT_SUCCESS, T1_REPORT],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };
